(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-section-text-with-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  const grid = document.getElementById('twp-grid-{{ section.id }}');
  const dots = document.getElementById('twp-dots-{{ section.id }}');
  if(!grid || !dots) return;

  const slides = Array.from(grid.querySelectorAll('.twp-card'));
  const dotEls = Array.from(dots.querySelectorAll('.twp-dot'));

  function updateEdgePadding(){
  const first = slides[0];
  if(!first) return;
  const viewport = grid.clientWidth;
  const cardW = first.clientWidth;
  const pad = Math.max(0, (viewport - cardW) / 2);
  grid.style.setProperty('--twp-edge', pad + 'px');
}
  function indexClosestToCenter(){
    const center = grid.scrollLeft + grid.clientWidth/2;
    let closestIdx = 0, closestDist = Infinity;
    slides.forEach((s,i)=>{
      const c = s.offsetLeft + s.clientWidth/2;
      const d = Math.abs(c - center);
      if(d < closestDist){ closestDist = d; closestIdx = i; }
    });
    return closestIdx;
  }

  function setActiveDot(idx){
    dotEls.forEach((d,i)=> d.classList.toggle('is-active', i === idx));
  }

  function scrollToIndex(idx, smooth=true){
    const el = slides[idx];
    if(!el) return;
    const left = el.offsetLeft - (grid.clientWidth - el.clientWidth)/2;
    grid.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
  }

  dotEls.forEach(d=>{
    d.addEventListener('click', ()=>{
      const idx = Number(d.getAttribute('data-target'));
      scrollToIndex(idx, true);
    });
  });

  let raf=null, idleTimer=null;
  function onScroll(){
    if(raf) return;
    raf = requestAnimationFrame(()=>{
      raf = null;
      const idx = indexClosestToCenter();
      setActiveDot(idx);
    });

    clearTimeout(idleTimer);
    idleTimer = setTimeout(()=>{
      const idx = indexClosestToCenter();
      scrollToIndex(idx, true);   
      setActiveDot(idx);
    }, 120); 
  }

  grid.addEventListener('scroll', onScroll, {passive:true});
  ['resize','orientationchange'].forEach(evt=>{
  window.addEventListener(evt, ()=>{
    updateEdgePadding();
    const idx = indexClosestToCenter();
    scrollToIndex(idx, false);
    setActiveDot(idx);
  });
});
  
  updateEdgePadding();

  // init
  const startIdx = indexClosestToCenter();
  scrollToIndex(startIdx, false);
  setActiveDot(startIdx);
})();



  } catch(e) { console.error(e); }
})();
})();
